import React from 'react';
import { motion } from 'framer-motion';
import { INTERNSHIP } from '../data/content';
import { CheckCircle2 } from 'lucide-react';

export default function Internship() {
  return (
    <section className="py-24 md:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-6 rounded-3xl overflow-hidden border border-line">
          <div className="lg:col-span-7 bg-white p-10 md:p-14">
            <div className="section-label">{INTERNSHIP.eyebrow}</div>
            <h2 className="font-display text-[38px] md:text-[52px] leading-[1.02] mt-5">
              {INTERNSHIP.title}
              <span className="grad-text-red">{INTERNSHIP.titleAccent}</span>
            </h2>
            <p className="mt-6 text-[16px] text-[color:var(--muted)] leading-relaxed max-w-lg">{INTERNSHIP.intro}</p>
            <ul className="mt-8 space-y-4">
              {INTERNSHIP.bullets.map((b, i) => (
                <motion.li
                  key={b}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="flex items-start gap-3 text-[15.5px] text-[color:var(--ink)]"
                >
                  <CheckCircle2 size={20} className="text-red mt-0.5 flex-shrink-0" />
                  {b}
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5 bg-[#1F2B73] text-white p-10 md:p-14 relative overflow-hidden">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#293891] blur-2xl opacity-70" />
            <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#E63329]/40 blur-3xl opacity-60" />
            <div className="relative">
              <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-white/70">By the numbers</div>
              <div className="mt-10 space-y-8">
                {INTERNSHIP.stats.map((s) => (
                  <div key={s.label} className="flex items-baseline gap-6 border-b border-white/10 pb-6">
                    <div className="font-display text-[68px] leading-none">{s.value}</div>
                    <div className="text-[11px] tracking-[0.22em] uppercase font-semibold text-white/70">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
